import cx from "classnames";
import { type FC } from "react";

import { type ColorVariant } from "../../../Chip/types";
import { TagColor } from "./TagColor";

export const TagColorChoice: FC<{
	color: ColorVariant;
	label: string;
	onClick?: (color: ColorVariant) => void;
	selected?: boolean;
}> = ({ color, label, onClick, selected }) => {
	return (
		<button
			data-selected={selected}
			// TODO: Replace this with `Tooltip` eventually. Tooltip shows on focus, while the
			// popover menu automatically focuses the first focusable element, and that can't be
			// turned off without managing focus manually, which is a lot of work. So, we have to
			// diable one or the other, and both give a hit to accessibility. Tab is used more than
			// screenreaders, so it wins here.
			title={label}
			className={cx(" flex cursor-pointer rounded-full outline-2", {
				"outline outline-brand": selected,
				"outline outline-transparent hover:outline-brand-light focus-visible:outline-brand-light focus:outline-brand-light active:outline-brand-active":
					!selected,
			})}
			onClick={() => onClick?.(color)}
		>
			<TagColor color={color} />
		</button>
	);
};
